module.exports = "/img/_/_/_/assets/images/creeper/battle/legendary//3.jpg?2d5483b9f5a84c02852da9f8eaee584b";